function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#464655",
  d: "M83 40.184H60v-3.377c0-.16.178-.29.396-.29h22.207c.219 0 .396.13.396.29v3.377H83z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFE15A",
  d: "M82.604 47.518H60.396c-.219 0-.396-.13-.396-.29v-3.377h23v3.377c0 .16-.177.29-.396.29z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FF4B55",
  d: "M60 40.184h23v3.666H60z"
});

function SvgFlagDe(props) {
  return React.createElement("svg", _extends({
    viewBox: "60 36.517 23 11"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjYwIDM2LjUxNyAyMyAxMSI+PHBhdGggZmlsbD0iIzQ2NDY1NSIgZD0iTTgzIDQwLjE4NEg2MHYtMy4zNzdjMC0uMTYuMTc4LS4yOS4zOTYtLjI5aDIyLjIwN2MuMjE5IDAgLjM5Ni4xMy4zOTYuMjl2My4zNzdIODN6Ii8+PHBhdGggZmlsbD0iI0ZGRTE1QSIgZD0iTTgyLjYwNCA0Ny41MThINjAuMzk2Yy0uMjE5IDAtLjM5Ni0uMTMtLjM5Ni0uMjl2LTMuMzc3aDIzdjMuMzc3YzAgLjE2LS4xNzcuMjktLjM5Ni4yOXoiLz48cGF0aCBmaWxsPSIjRkY0QjU1IiBkPSJNNjAgNDAuMTg0aDIzdjMuNjY2SDYweiIvPjwvc3ZnPg==";
export { SvgFlagDe as ReactComponent };